module.exports = __webpack_public_path__ + "img/md-color-filter.7058497f.svg";